
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  name: 'AppSocialMediaInfoSection',
  props: {
    review: {
      type: Object,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    SocialMediaType: () => SocialMediaType,
    socialMediaUrl() {
      switch (this.review.social_media_type) {
        case SocialMediaType.FACEBOOK:
          return 'FACEBOOK.COM';
        case SocialMediaType.INSTAGRAM:
          return 'INSTAGRAM.COM';
        case SocialMediaType.NAVER_CAFE:
          return 'NAVER.CAFE.COM';
        case SocialMediaType.NAVER_BLOG:
          return 'NAVER.BLOG.COM';
        case SocialMediaType.YOUTUBE:
          return 'YOUTUBE.COM';
        case SocialMediaType.VIMEO:
          return 'VIMEO.COM';
        default:
          return '';
      }
    }
  }
};
